module.exports = __webpack_public_path__ + "img/page_image_2_3.a4ba5956.svg";